import React, { useEffect, useRef, useState } from 'react';
import { CloseRounded } from '@material-ui/icons';
import styles from './styles';
import { Button } from '@material-ui/core';
import clsx from 'clsx';
import { useNotify } from 'react-admin';
import { ReactSVG } from 'react-svg';
import { Icons } from '@/assets';
import Table from '@/ctComponents/Table';
import { formatDateTimeToUTC, formatDateToUTC } from '@/ctUtlis/formatDate';
import { removeNoScroll } from '@/actions/Helper';
import CloseButton from '@/ctComponents/closeButton';
import SubmitButton from '@/ctComponents/submitButton';

export default ({
  Close,
  DATA,
  requestedCount,
  setSelectedContainerItem,
  preApprovedContainers,
  selectedContainerItem,
}) => {
  const cls = styles();
  const wrapperRef = useRef(null);
  const cardRef = useRef(null);
  const notify = useNotify();

  const [tableData, setTableData] = useState([]);
  const [selectData, setSelectData] = useState([]);
  const [fixed, setFixed] = useState(false);
  const [scrollLeft, setScrollLeft] = useState('-24px');
  const [tableWrapperWidth, setTableWrapperWidth] = useState(0);

  const handleScroll = (body) => {
    if (body.target?.scrollTop > 100) {
      console.log('fixed');
      setFixed(true);
    } else {
      setFixed(false);
    }
  };
  useEffect(() => {
    const card = cardRef.current;
    if (!card) return;

    const handleScrollOrResize = () => {
      if (card.scrollWidth > card.clientWidth) {
        setScrollLeft(card.scrollLeft - 24);
      } else {
        setScrollLeft('unset');
      }
    };

    card.addEventListener('scroll', handleScrollOrResize);
    window.addEventListener('resize', handleScrollOrResize);

    handleScrollOrResize();

    return () => {
      card.removeEventListener('scroll', handleScrollOrResize);
      window.removeEventListener('resize', handleScrollOrResize);
    };
  }, [cardRef]);

  useEffect(() => {
    const body = wrapperRef.current;
    console.log('body', body.clientWidth);
    if (!body) return;
    const handleResize = () => {
      setTableWrapperWidth(body.clientWidth - 17);
    };
    handleScroll(body);
    // Set width immediately on mount
    handleResize();
    body.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleResize);
    return () => {
      body.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleResize);
    };
  }, [wrapperRef]);

  useEffect(() => {
    setSelectData(selectedContainerItem.map((item) => item.preApproverowID));
  }, [selectedContainerItem, DATA]);

  const formatPrice = (price) => {
    if (price) {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(price);
    } else return '-';
  };

  const handleSelectData = (RowId) => {
    if (!selectData.includes(RowId)) {
      if (requestedCount > selectData.length) {
        setSelectData((prevSelected) => [...prevSelected, RowId]);
      } else {
        notify(
          `You can select a maximum of ${requestedCount} containers only.`,
          'warning'
        );
      }
    } else {
      setSelectData((prevSelected) =>
        prevSelected.filter((id) => id !== RowId)
      );
    }
  };
  const handleSave = () => {
    const result = tableData
      .filter((row) => selectData.includes(row.id))
      .map((row) => ({
        item: row,
        preApproverowID: selectData.find((select) => select === row.id),
      }));
    setSelectedContainerItem(result);
    removeNoScroll();
    Close();
  };
  React.useEffect(() => {
    const Datatable = DATA.inventory.containers
      ?.filter((item) => item.status === 1)
      .map((item, idx) => ({
        ...item,
        id: item.id,
        idx: idx + 1,
        preApproverowID: item.id,
        ssl: DATA.ssl,
        size: DATA.size,
        container: item.name || item.container?.name,
        chassis: item.chases || item.container?.chases,
        gated_out: item.gated_out
          ? formatDateTimeToUTC(item.gated_out)
          : item.container?.gated_out
          ? formatDateTimeToUTC(item.container.gated_out)
          : '-',
        empty_location:
          item.container?.pickup_location || DATA.inventory?.address?.city,
        return_apt: item.return_appointment
          ? formatDateTimeToUTC(item.return_appointment)
          : item.container?.return_appointment
          ? formatDateTimeToUTC(item.container.return_appointment)
          : '-',
        return_location: item.return_terminals || '-',
        dual_terminal: item.return_dual_terminals || '-',
        lfd: item.last_free_day
          ? formatDateToUTC(item.last_free_day)
          : item.container?.last_free_day
          ? formatDateToUTC(item.container.last_free_day)
          : '-',
        est_per_diem: item.est_per_diem
          ? formatPrice(item.est_per_diem)
          : item.container?.est_per_diem
          ? formatPrice(item.container.est_per_diem)
          : '-',
        chassis_type:
          item?.own_chases === 1 || item.container?.own_chases === 1
            ? 'Own'
            : 'Pool',
        last_update: item.updated_at
          ? formatDateTimeToUTC(item.updated_at)
          : item.container?.updated_at
          ? formatDateTimeToUTC(item.container.updated_at)
          : '-',
      }));

    setTableData(Datatable);
  }, [DATA]);

  const columns = [
    {
      field: 'idx',
      label: '#',
      align: 'center',
      fontSize: '12px',
      width: '30px',
      flex: 0.3,
    },
    {
      field: 'ssl',
      label: 'SSL',
      align: 'center',
      fontSize: '12px',
      width: '80px',
      flex: 0.8,
    },
    {
      field: 'size',
      label: 'Size',
      align: 'center',
      fontSize: '12px',
      width: '80px',
      flex: 0.8,
    },
    {
      field: 'container',
      label: 'Container',
      align: 'center',
      fontSize: '12px',
      width: '100px',
      flex: 1,
    },
    {
      field: 'chassis',
      label: 'Chassis',
      align: 'center',
      fontSize: '12px',
      width: '80px',
      flex: 0.8,
    },
    {
      field: 'gated_out',
      label: 'Gated Out',
      align: 'center',
      fontSize: '12px',
      width: '100px',
      flex: 1,
    },
    {
      field: 'empty_location',
      label: 'Empty Location',
      align: 'center',
      fontSize: '12px',
      width: '80px',
      flex: 0.8,
    },
    {
      field: 'return_apt',
      label: 'Return Apt',
      align: 'center',
      fontSize: '12px',
      width: '80px',
      flex: 0.8,
    },
    {
      field: 'return_location',
      label: 'Single Transaction',
      align: 'center',
      fontSize: '12px',
      width: '120px',
      flex: 1.2,
    },
    {
      field: 'dual_terminal',
      label: 'Dual Only Transaction',
      align: 'center',
      fontSize: '12px',
      width: '100px',
      flex: 1,
    },
    {
      field: 'lfd',
      label: 'LFD',
      align: 'center',
      fontSize: '12px',
      width: '80px',
      flex: 0.8,
    },
    {
      field: 'est_per_diem',
      label: 'Est.PerDiem',
      align: 'center',
      fontSize: '12px',
      width: '70px',
      flex: 0.7,
    },
    {
      field: 'chassis_type',
      label: 'Chassis Type',
      align: 'center',
      fontSize: '12px',
      width: '80px',
      flex: 0.8,
    },
    {
      field: 'last_update',
      label: 'Last Update',
      align: 'center',
      fontSize: '12px',
      width: '100px',
      flex: 1,
    },
  ];
  const getRowStyle = (row) => {
    if (
      preApprovedContainers === 'preApprovedContainers' &&
      DATA.preapprovedcontainer?.container.id === row.container?.id
    ) {
      return { backgroundColor: '#EBF1FF', border: '1px solid #335CFF' };
    } else if (DATA?.id === row?.id) {
      return { backgroundColor: '#EBF1FF', border: '1px solid #335CFF' };
    }
    return {};
  };

  return (
    <div id="app_modal" className={cls.popup}>
      <div className={cls.card} ref={cardRef}>
        <div className={cls.cardContent}>
          {/*<div style={{ width: '100%', position: 'relative' }}>
            <CloseRounded className={cls.closePx} onClick={Close} />
          </div>*/}

          <div ref={wrapperRef}>
            <span className={cls.tableTopActions}>
              <ReactSVG
                src={Icons.containerTruck}
                className={cls.dicsounticon}
              />
              Select Containers to Pre-Approve and Share
            </span>
            <div className="mb-2 text-sm leading-relaxed">
              <span className="whitespace-nowrap">
                Check the boxes next to the containers
              </span>{' '}
              <span className="whitespace-nowrap">
                to pre-approve and click
              </span>{' '}
              <b className="mx-1 whitespace-nowrap">" Submit "</b>{' '}
              <span className="whitespace-nowrap">to confirm.</span>
            </div>
            <div style={{ overflow: 'hidden' }}>
              <Table
                columns={columns}
                data={tableData || []}
                totalCount={0}
                keyField="id"
                handleSelectData={handleSelectData}
                selectData={selectData}
                getRowStyle={getRowStyle}
                check={true}
                icons={null}
                fixed={fixed}
                // scrollLeft={scrollLeft}
                mini={true}
                scroll={true}
                height={'404px'}
                width={'fit-content'}
                componentName={'preApproveContainers'}
                tableWrapperWidth={tableWrapperWidth}
                parent={'addContainerInbox'}
              />
            </div>
          </div>
          <span className={cls.containerSelectPopupBtns}>
            <CloseButton
              color="#131517"
              onClick={() => {
                removeNoScroll();
                Close();
              }}
              text="Cancel"
            />

            {preApprovedContainers === 'preApprovedContainers' ? (
              ''
            ) : (
              <SubmitButton
                onClick={() => {
                  handleSave();
                }}
                text={` Submit ${selectData.length} selected`}
              />
            )}
          </span>
        </div>
      </div>
    </div>
  );
};
